module.exports = function getResource(label, vars = []) {
    let resources = {
        openUntil: `Ouvert jusqu’à ${vars[0]}`,
        closed: 'Fermé',
        storeHoursUnavailable: 'Heures d’ouverture non disponibles'
    };
    return resources[label];
};
